import en from './en'
import zh from './zh'
export default {
  en,
  zh
}



// WEBPACK FOOTER //
// ./src/i18n/lang/index.js